(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaHistoricoDesvincularController', NormaHistoricoDesvincularController);

    NormaHistoricoDesvincularController.$inject = ['$uibModalInstance', 'entity', 'vigenteId', 'Norma'];

    function NormaHistoricoDesvincularController($uibModalInstance, entity, vigenteId, Norma) {
        var vm = this;

        vm.norma = entity;// el histórico que se va a desvincular
        vm.isSaving = false;
        vm.clear = clear;
        vm.desvincular = desvincular;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function desvincular() {
            vm.isSaving = true;
            Norma.desvincular({id: vm.norma.id, vigenteId: vigenteId}, {}, onSuccess, onError);
        }

        function onSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onError() {
            vm.isSaving = false;
        }
    }
})();
